/**
 * MatchReview.tsx · 09_APP · OS-006 · 2026-10-20 · v69
 *
 * Her words: "the waiting on you is you can't click on anything on that page."
 * "Possible match to check" now opens here: the two records side by side, and two buttons. "Same person" combines
 * them (everything moves to one record, nothing is deleted, merge_log keeps the trail). "Different people" keeps both.
 */

import { useEffect, useState } from "react";
import { os, type MatchPair } from "../lib/os";

function Side({ p }: { p: MatchPair["a"] }) {
  return (
    <div className="mr-side">
      <a href={`#people/${p.id}`}><b>{p.name}</b></a>
      {p.org && <span>{p.org}</span>}
      {(p.emails ?? []).map((e) => <span key={e}>{e}</span>)}
      {(p.phones ?? []).map((ph) => <span key={ph}>{ph}</span>)}
      <small>In since {p.since} · {p.history} {p.history === 1 ? "entry" : "entries"} of history</small>
    </div>
  );
}

export function MatchReview({ onDone }: { onDone: (left: number) => void }) {
  const [list, setList] = useState<MatchPair[] | null>(null);
  const [busy, setBusy] = useState<string | null>(null);
  const [err, setErr] = useState<string | null>(null);
  useEffect(() => { os.matchList().then(setList).catch((e) => setErr(String(e?.message ?? e))); }, []);

  async function decide(id: string, same: boolean) {
    setBusy(id); setErr(null);
    try { const l = await os.matchDecide(id, same); setList(l); onDone(l.length); }
    catch (e) { setErr(e instanceof Error ? e.message : String(e)); }
    finally { setBusy(null); }
  }

  if (err) return <div className="refusebox">{err}</div>;
  if (!list) return <p className="muted">Opening…</p>;
  if (list.length === 0) return <p className="muted">Nothing left to check.</p>;
  return (
    <div className="mr">
      {list.map((m) => (
        <div key={m.id} className="mr-pair">
          <p className="mr-why">Why they look alike: {m.why}</p>
          <div className="mr-sides"><Side p={m.a} /><Side p={m.b} /></div>
          <div className="mr-btns">
            <button className="mr-same" disabled={busy === m.id} onClick={() => void decide(m.id, true)}>Same person, combine them</button>
            <button disabled={busy === m.id} onClick={() => void decide(m.id, false)}>Different people, keep both</button>
          </div>
        </div>
      ))}
    </div>
  );
}
